import type { GetRequestStatisticsResponse } from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";

import apiClient from "@/lib/api/client";

export function useProjectRequestStatistics(projectId: number) {
  return useQuery({
    enabled: !!projectId,
    gcTime: 15 * 60 * 1000,
    queryFn: async () =>
      apiClient
        .url("/requests/list/statistics")
        .query({ projectId })
        .get()
        .json<GetRequestStatisticsResponse>(),
    queryKey: ["project-requests", "statistics", projectId],
    staleTime: 5 * 60 * 1000,
  });
}
